import { Vault } from '@/features/vaults/types';
import { LidoStrategyTitleHeader } from '@/shared/components/WhiteLabelTitleHeaders/LidoStrategyTitleHeader';

export const lidoEarnUsdVaultId = 'earn-usd';

export const lidoEarnUsd: Vault = {
  id: lidoEarnUsdVaultId,
  type: 'core-vault',
  name: 'EarnUSD',
  description:
    'EarnUSD provides on-chain access to strategies involving USD-denominated digital assets. It uses defined asset selection and risk controls, supported by transparent reporting.',
  category: 'core-vault',
  address: '0x014e6DA8F283C4aF65B2AA0f201438680A004452',
  whiteLabeling: {
    curatorId: 'mellow',
    subdomain: 'earn-usd',
  },
  curators: ['lido', 'mellow'],
  operator: [],
  points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: '0x014e6DA8F283C4aF65B2AA0f201438680A004452',
    },
  ],
  baseToken: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  lpTokenSymbol: 'earnUSD',
  lpTokenDecimals: 18,
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  callConfigOrigin: {
    branch: 'main',
    filenamePrefix: 'ethereum:earnUSD',
  },
  allocations: {
    showAllocationsTab: true,
    showAllocationsTable: true,
    octavProLink: 'https://mellow.octav.fi/app/earnUSD',
    debankBundleId: '221534',
  },
  vaultTitleHeader: <LidoStrategyTitleHeader link="https://stake.lido.fi/earn/usd/deposit" />,
  displayNoMellowCuration: true,
};
